module.exports = __webpack_public_path__ + "static/media/profile-large.440685a0.png";